export function calcX(x, width, fullWidth, minWidth) {
    var w = Math.max(minWidth / fullWidth, width / fullWidth)
    return x * w;
}
